module.exports = __webpack_public_path__ + "img/2.0b6d5d49.png";